import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sentimentIcon',
  standalone: true,
})
export class SentimentIconPipe implements PipeTransform {
  transform(value: string | number | string[] | undefined): string {
    if (typeof value === 'string' && value.trim().length > 0) {
      const iconMap: Record<string, string> = {
        Positive: 'assets/icons/emoji_slightly_smiling_face_.svg',
        Negative: 'assets/icons/emoji_slightly_frowning_face_.svg',
        Neutral: 'assets/icons/emoji_neutral_face_.svg',
      };

      return iconMap[value] || 'assets/icons/emoji_default.svg';
    }

    return 'assets/icons/emoji_default.svg';
  }
}
